//Module Import
//Icons
import greaseIcon from '../resource/icons/ic_bevo_fett_48.svg';
import brakeFluidIcon from '../resource/icons/ic_bevo_breaking-fluid_48.svg';
import fuelIcon from '../resource/icons/ic_bevo_fuel-comp_48.svg';
import hydraulicOilIcon from '../resource/icons/ic_bevo_hydraulikoel_48.svg';
// import stearingGearIcon from '../resource/icons/
import axleOilIcon from '../resource/icons/ic_bevo_lenkgetriebe_48.svg';
import stearingGearIcon from '../resource/icons/Lenkgetriebe.svg';
import adBlueIcon from '../resource/icons/ic_bevo_NOx-Reduktionsmittel_48.svg';
import engineOilIcon from '../resource/icons/ic_bevo_motorEngine.svg';
import washerFluidIcon from '../resource/icons/ic_bevo_washer-fluid_48.svg';
import refrigeratorOilIcon from '../resource/icons/ic_bevo_kompressor_48.svg';
import transmissionIcon from '../resource/icons/ic_bevo_transmission_48.svg';
import preservationIcon from '../resource/icons/ic_bevo_konservierungsstoffe_48.svg';
import coolantIcon from '../resource/icons/ic_bevo_korrosions-frostschutz_48.svg';
import refrigerantIcon from '../resource/icons/ic_bevo_kaeltemittel_48.svg';
import electricEngineIcon from '../resource/icons/E-Motor.svg';
import edacIcon from '../resource/icons/EdAc.svg';
import cleanerIcon from '../resource/icons/cleaner.svg';

// Categoty header images
import adBlueHeader from '../resource/image/adBlueHeader.jpg';
import categoryHeader from '../resource/image/categoryHeader.jpg';
import CleanerHeader from '../resource/image/CleanerHeader.jpg';
import GetriebeHeader from '../resource/image/GetriebeHeader.jpg';
import KühlantHeader from '../resource/image/KühlantHeader.jpg';
import MotorHeader from '../resource/image/MotorHeader.jpg';

// Media Query breakpoint
export const MEDIA_QUERY_BREAKPOINT_TABLE_NUMBER = 900;
export const MEDIA_QUERY_BREAKPOINT = '(max-width: 720px)';
export const MEDIA_QUERY_BREAKPOINT_TABLE = `(max-width: ${MEDIA_QUERY_BREAKPOINT_TABLE_NUMBER}px)`;

// API
export const BASE_URL =
    process.env.NODE_ENV === 'production'
        ? '/api/v1/'
        : 'http://localhost:8082/api/v1/';

// export const BASE_URL = 'http://localhost:8080/api/v1/';
// export const BASE_URL = 'https://bevo-dev.trucks.app.corpintra.net/api/v1/';

// Categories
export const CATEGORY_PROPS = [
    /* {
     icon: infoIcon,
     image: categoryHeader,
     description: 'Info',
     link: '/general-information',
     }, */
    {
        icon: engineOilIcon,
        image: MotorHeader,
        static: false,
        sheeTitle: "EngineOil",
        staticDetails: "",
        description: 'EngineOil',
        link: '/engine-oil',
        sheetPrefix: 15,
        metaDescription: {
            en: 'Explore approved axle oil specifications for Mercedes-Benz Trucks. Optimized for durability in heavy-duty applications.',
            de: 'Entdecke alle freigegebenen Achsöle und Spezifikationen für Lastkraftwagen von Mercedes-Benz Trucks. Abgestimmt auf den Einsatz unter anspruchsvollen Belastungen.',
            pt: 'Óleos de eixo aprovados para aplicações exigentes – freios eixos homologados para caminhões como o Actros, Arocs e Atego da Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Axle oil', 'Approved axle oil', 'Mercedes-Benz', 'Truck', 'Actros', 'Arocs', 'Atego', 'Unimog', 'heavy-duty'],
            de: ['Achsöl', 'Freigegebene Achsöle', 'Lastkraftwagen', 'Actros', 'Arocs', 'Mercedes-Benz', 'Truck', 'Atego'],
            pt: ['Óleo de eixo', 'Óleos de eixo aprovado', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'caminhõe']
        }
    },
    {
        icon: brakeFluidIcon,
        image: categoryHeader,
        static: false,
        sheeTitle: "BrakeFluid",
        staticDetails: "",
        description: 'BrakeFluid',
        link: '/brake-fluid',
        sheetPrefix: 30,
        metaDescription: {
            en: 'Approved brake fluids and specifications for brake fluids in trucks, semi-trailers, and heavy-duty commercial vehicles from Mercedes-Benz Truck.',
            de: 'Freigegebene Bremsflüssigkeiten und Spezifikationen für Bremsflüssigkeiten in Lkw, Sattelzügen und schweren Nutzfahrzeugen von Mercedes-Benz Truck.',
            pt: 'Fluidos de freio aprovados e especificações para fluidos de freio em caminhões, carretas e veículos comerciais pesados da Mercedes-Benz Truck.'
        },
        keywords: {
            en: ['Approved brake fluid', 'Brake fluid', 'Truck', 'heavy-duty', 'commercial vehicle', 'Mercedes-Benz'],
            de: ['Freigegebene Bremsflüssigkeit', 'Bremsflüssigkeit', 'Lkw', 'Mercedes-Benz', 'Truck', 'Nutzfahrzeug'],
            pt: ['Fluido de freio aprovado', 'fluido de freio', 'caminhõe', 'veículos comerciais', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: fuelIcon,
        image: categoryHeader,
        description: 'Fuel',
        static: false,
        sheeTitle: "Fuel",
        staticDetails: "",
        link: '/fuel',
        sheetPrefix: 16,
        metaDescription: {
            en: 'Informative overview of approved fuel types for Mercedes-Benz Trucks, including diesel, hydrogen and other fuels. Includes fuel cell system guidelines and usage notes.',
            de: 'Technische Informationen zu Kraftstoffen für Mercedes-Benz Trucks: Unterschiede, Anforderungen und Freigabenormen für Diesel, Wasserstoff und alternativen Kraftstoffen.',
            pt: 'Informações técnicas sobre combustíveis aprovados para caminhões da Mercedes-Benz Truck, incluindo diesel, hidrogênio e outras opções utilizadas.'
        },
        keywords: {
            en: ['Fuel', 'Mercedes-Benz', 'Truck', 'Diesel', 'Hydrogen', 'Fuel cell'],
            de: ['Kraftstoff', 'Mercedes-Benz', 'Truck', 'Freigabenorm', 'Diesel', 'Wasserstoff', 'Alternative Kraftstoffe'],
            pt: ['combustível', 'caminhõe', 'Mercedes-Benz', 'Truck', 'Diesel', 'Hidrogênio']
        }
    },
    {
        icon: transmissionIcon,
        image: GetriebeHeader,
        description: 'GearOil',
        static: false,
        sheeTitle: "GearOil",
        staticDetails: "",
        link: '/gear-oil',
        sheetPrefix: 13,
        metaDescription: {
            en: 'Approved automatic transmission fluids and gear oils for Mercedes-Benz Trucks such as Actros, Arocs, Atego, Unimog and more!',
            de: 'Offizielle Herstellerinformationen und freigegebene Getriebeöle für Actros, Arocs, Atego und alle weiteren Modelle von Mercedes-Benz Trucks – abgestimmt auf alle Getriebearten!',
            pt: 'Óleos de transmissão aprovados para Actros, Arocs, Atego ou outros modelos da Mercedes-Benz Trucks – ideais para troca de óleo em câmbio automático e manual!'
        },
        keywords: {
            en: ['automatic transmission fluid', 'Gear oil', 'Mercedes-Benz', 'Truck', 'Actros', 'Arocs', 'Atego', 'Unimog'],
            de: ['Offizielle Herstellerinformationen', 'Freigegebene Getriebeöle', 'Getriebeöl', 'Actros', 'Arocs', 'Mercedes-Benz', 'Truck', 'Atego'],
            pt: ['Óleo de transmissão', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'troca de óleo', 'câmbio automático', 'câmbio manual']
        }
    },
    {
        icon: greaseIcon,
        image: categoryHeader,
        description: 'Grease',
        static: false,
        sheeTitle: "Grease",
        staticDetails: "",
        link: '/grease',
        sheetPrefix: 33,
        metaDescription: {
            en: 'Learn more about heavy-duty grease products, including NLGI 2 and multipurpose lubrication, for Mercedes-Benz Trucks.',
            de: 'Mehrzweckfette, NLGI 2-Schmierstoffe und weitere Fette für alle Mercedes-Benz Trucks – abgestimmt auf vielfältige Anwendungen im Nutzfahrzeugbereich.',
            pt: 'Seleção de graxas e pastas aprovadas para rolamentos e componentes críticos em caminhões da Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Heavy-duty grease', 'heavy-duty', 'NLGI', 'NLGI 2', 'Lubrication', 'Mercedes-Benz', 'Truck', 'multipurpose grease'],
            de: ['Mehrzweckfett', 'NLGI', 'NLGI 2', 'Fett', 'Mercedes-Benz', 'Truck', 'Nutzfahrzeug', 'Nutzfahrzeugbereich', 'Paste'],
            pt: ['Graxa', 'Pasta', 'caminhõe', 'Mercedes-Benz', 'Truck', 'Graxa para rolamentos']
        }
    },
    {
        icon: hydraulicOilIcon,
        image: categoryHeader,
        description: 'HydraulicFluid',
        static: false,
        sheeTitle: "HydraulicFluid",
        staticDetails: "",
        link: '/hydraulic-fluid',
        sheetPrefix: 31,
        metaDescription: {
            en: 'Approved hydraulic fluids for Mercedes-Benz Trucks. Technical overview of hydraulic oil specifications for heavy-duty assemblies such as Actros, Arocs or Unimog.',
            de: 'Freigegebene Hydrauliköle für Actros, Arocs, Atego und co – abgestimmt auf die Spezifikationen und Anforderungen von Mercedes-Benz Trucks.',
            pt: 'Fluidos hidráulicos indicados para aplicações pesadas em caminhões como Actros, Arocs, Atego e outros veículos da Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Hydraulic Fluid', 'Mercedes-Benz', 'Truck', 'heavy-duty', 'Actros', 'Arocs', 'Unimog', 'Hydraulic Oil'],
            de: ['Hydrauliköl', 'Hydraulikflüssigkeit', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'Unimog'],
            pt: ['Fluido hidráulico', 'caminhõe', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: preservationIcon,
        image: categoryHeader,
        description: 'PreservationAgent',
        static: false,
        sheeTitle: "PreservationAgent",
        staticDetails: "",
        link: '/preservation-agent',
        sheetPrefix: 34,
        metaDescription: {
            en: 'Preservation solutions for Mercedes-Benz Trucks. Protect heavy-duty vehicles from rust and corrosion with approved preservation agents and long-term sealing solutions.',
            de: 'Freigegebene Konservierungsmittel für Mercedes-Benz Trucks – Produkte für Hohlraumversiegelung, Unterbodenschutz und langfristige Fahrzeugkonservierung.',
            pt: 'Soluções de vedação de cavidades e proteção anticorrosiva aprovadas para veículos comerciais pesados – para Actros, Arocs, Atego e demais da Mercedes-Benz Truck.'
        },
        keywords: {
            en: ['Preservation', 'Preservation Agent', 'Heavy-duty', 'rust protection', 'corrosion protection', 'sealing solution', 'Mercedes-Benz', 'Truck'],
            de: ['Konservierungsmittel', 'Hohlraumversiegelung', 'Unterbodenschutz', 'Fahrzeugkonservierung', 'Mercedes-Benz', 'Truck', 'Hohlraum', 'Versiegelung'],
            pt: ['vedação de cavidades', 'proteção anticorrosiva', 'veículos comerciais', 'conservante', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: refrigeratorOilIcon,
        image: categoryHeader,
        description: 'RefrigeratorOil',
        static: false,
        sheeTitle: "RefrigeratorOil",
        staticDetails: "",
        link: '/compressor-oil',
        sheetPrefix: 36,
        metaDescription: {
            en: 'Approved refrigerator oils in air conditioning systems from Mercedes-Benz Trucks.',
            de: 'Freigegebene Kältekompressoröle in Klimaanlagen von Mercedes-Benz Trucks.',
            pt: 'Óleos aprovados para compressores de refrigeração em sistemas de ar-condicionado da Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Refrigerator oil', 'Air conditioner', 'Mercedes-Benz', 'Truck'],
            de: ['Kältekompressor', 'Kältekompressoröl', 'Klimaanlage', 'Mercedes-Benz', 'Truck'],
            pt: ['compressor de refrigeração', 'ar-condicionado', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: stearingGearIcon,
        image: categoryHeader,
        description: 'SteeringGearOil',
        static: false,
        sheeTitle: "SteeringGearOil",
        staticDetails: "",
        link: '/stearing-gear-oil',
        sheetPrefix: 38,
        metaDescription: {
            en: 'Technical information and approved steering gear oils for trucks and heavy-duty commercial vehicles from Mercedes-Benz Truck.',
            de: 'Technische Informationen und freigegebene Lenkgetriebeöle für Lkw und schwere Nutzfahrzeuge von Mercedes-Benz Truck.',
            pt: 'Informações técnicas e óleos de direção aprovados para caminhões e veículos comerciais pesados da Mercedes-Benz Truck.'
        },
        keywords: {
            en: ['Steering gear', 'Steering gear oil', 'heavy-duty', 'commercial vehicle', 'Mercedes-Benz', 'Truck'],
            de: ['Lenkgetriebe', 'Lenkgetriebeöl', 'Lkw', 'Nutzfahrzeug', 'Mercedes-Benz', 'Truck'],
            pt: ['óleo de direção', 'caminhõe', 'veículos comerciais', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: adBlueIcon,
        image: adBlueHeader,
        description: 'AdBlue',
        static: false,
        sheeTitle: "AdBlue",
        staticDetails: "",
        link: '/NOx-reducing-agent',
        sheetPrefix: 17,
        metaDescription: {
            en: 'Technical information and usage guidelines for NOx reduction agents (AdBlue) in Mercedes-Benz Trucks.',
            de: 'Technische Informationen und Anwendungshinweise zu NOx-Reduktionsmitteln (AdBlue) für Mercedes-Benz Trucks.',
            pt: 'Informações técnicas e orientações de uso para agentes redutores de NOx (AdBlue) em Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['NOx Reducing Agent', 'AdBlue', 'Mercedes-Benz', 'Truck'],
            de: ['NOx-Reduktionsmittel', 'AdBlue', 'Mercedes-Benz', 'Truck'],
            pt: ['Agente de redução de Nox', 'AdBlue', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: coolantIcon,
        image: KühlantHeader,
        description: 'Coolant',
        link: '/coolant',
        static: false,
        sheeTitle: "Coolant",
        staticDetails: "",
        sheetPrefix: 29,
        metaDescription: {
            en: 'Explore approved coolants for Mercedes-Benz Trucks, including antifreeze concentrate and ready-mix variants.',
            de: 'Zugelassene Kühlflüssigkeiten für Actros, Arocs, Atego und weitere Modelle von Mercedes-Benz Trucks, verfügbar als Kühlmittel-Konzentrat oder Readymix mit Frost- und Korrosionsschutz.',
            pt: 'Conheça os produtos de arrefecimento para Actros, Arocs, Atego e outros modelos da Mercedes-Benz Trucks – com especificações técnicas e normas atendidas.'
        },
        keywords: {
            en: ['Approved coolants', 'Coolant', 'Mercedes-Benz', 'Truck', 'antifreeze', 'concentrate', 'ready mix'],
            de: ['Zugelassene Kühlflüssigkeiten', 'Kühlflüssigkeit', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'Kühlmittel', 'Konzentrat', 'ready mix'],
            pt: ['produto de arrefecimento', 'Actros', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'especificações técnica', 'refrigerante', 'readymix']
        }
    },
    {
        icon: refrigerantIcon,
        image: categoryHeader,
        description: 'Refrigerant',
        link: '/refrigerant',
        static: false,
        sheeTitle: "Refrigerant",
        staticDetails: "",
        sheetPrefix: 35,
        metaDescription: {
            en: 'Information on refrigerants (R134a, R1234yf) and their use in air conditioning systems of Mercedes-Benz Trucks.',
            de: 'Informationen zu Kältemitteln (R134a, R1234yf) und deren Verwendung in Klimaanlagen von Mercedes-Benz Trucks.',
            pt: 'Informações sobre fluidos refrigerantes (R134a, R1234yf) e seu uso em sistemas de ar-condicionado de Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Refrigerant', 'R134a', 'R1234yf', 'Air conditioner', 'Mercedes-Benz', 'Truck'],
            de: ['Kältemittel', 'R134a', 'R1234yf', 'Klimaanlage', 'Mercedes-Benz', 'Truck'],
            pt: ['fluido refrigerante', 'R134a', 'R1234yf', 'ar-condicionado', 'Mercedes-Benz', 'Truck']
        }
    },
    {
        icon: washerFluidIcon,
        image: categoryHeader,
        description: 'Windshield',
        link: '/windshield-washer-fluid-concentrate',
        static: false,
        staticDetails: "",
        sheeTitle: "Windshield",
        sheetPrefix: 38,
        metaDescription: {
            en: 'Windshield cleaner concentrate for all Mercedes-Benz Truck models such as Actros, Arocs or Atego. High-performance summerfit and winterfit wiper fluids.',
            de: 'Winterfit- und Summerfit-Konzentrate für Mercedes-Benz Trucks: freigegebene Produkte für den ganzjährigen Einsatz.',
            pt: 'Líquidos limpadores de vidro concentrados para todos os modelos da Mercedes-Benz Truck, ideais para o para-brisa em condições de verão e inverno.'
        },
        keywords: {
            en: ['Windshield cleaner', 'Windshield', 'windshield wiper fluid', 'summerfit', 'winterfit', 'Actros', 'Atego', 'Arocs', 'Mercedes-Benz', 'Truck'],
            de: ['Winterfit', 'summerfit', 'Scheibenwischer', 'readymix', 'wischwasser', 'Mercedes-Benz', 'Truck'],
            pt: ['Líquido limpador', 'para brisa', 'concentrado', 'Líquido limpador de vidro', 'Mercedes-Benz', 'Truck', 'caminhõe']
        }
    },
    {
        icon: edacIcon,
        image: categoryHeader,
        description: 'edAC-Oil',
        link: '/edAC-Oil',
        static: false,
        sheeTitle: "edAC-Oil",
        staticDetails: "",
        sheetPrefix: 32,
        metaDescription: {
            en: 'Approved products in the edAC-oil category for Mercedes-Benz Trucks.',
            de: 'Freigegebene Produkte der Kategorie edAC-Öl für Mercedes-Benz Trucks.',
            pt: 'Produtos aprovados na categoria óleo edAC para Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Approved products', 'edAC-oil', 'edAC', 'Mercedes-Benz', 'Truck', 'compressor-oil', 'AC compressor', 'A/C'],
            de: ['Freigegebene Produkte', 'edAC-Öl', 'edAC', 'Mercedes-Benz', 'Truck', 'Kompressor-Öl', 'Klimakompressor', 'Klimaanlage'],
            pt: ['Produto aprovado', 'edAC', 'Mercedes-Benz', 'Truck', 'óleo do compressor', 'Ar condicionado', 'compressor do ar condicionado', 'Compressor']
        }
    },
    {
        icon: electricEngineIcon,
        image: categoryHeader,
        description: 'E-Drive',
        link: '/E-Drive',
        static: false,
        sheeTitle: "E-Drive",
        staticDetails: "",
        sheetPrefix: 10,
        metaDescription: {
            en: 'Approved gear oils for electric axles in Mercedes-Benz Trucks. Suitable for all models with electric drive axles for heavy-duty use as the eActros 600.',
            de: 'Freigegebene Getriebeöle für E-Achsen von Mercedes-Benz Trucks. Geeignet für alle Modelle mit elektrischen Antriebsachsen im schweren Nutzfahrzeugbereich wie dem eActros 600.',
            pt: 'Óleos de transmissão aprovados para eixos elétricos em caminhões de Mercedes-Benz Trucks. Adequados para todos os modelos com eixos de tração elétrica como eActros 600.'
        },
        keywords: {
            en: ['electric axle', 'Mercedes-Benz', 'Truck', 'eActros', 'eActros 600', 'electric drive axle', 'Gear oil'],
            de: ['Getriebeöl', 'E-Achse', 'Mercedes-Benz', 'Truck', 'elektrische Antriebsachse', 'eActros', 'eActros 600', 'Nutzfahrzeug'],
            pt: ['Óleo de transmissão', 'eixo elétrico', 'caminhõe', 'Mercedes-Benz', 'Truck', 'eixo de tração elétrica', 'eActros', 'eActros 600']
        }
    },
    {
        icon: axleOilIcon,
        image: categoryHeader,
        description: 'Axle-Oil',
        link: '/Axle-Oil',
        static: false,
        sheeTitle: "Axle-Oil ",
        staticDetails: "",
        sheetPrefix: 11,
        metaDescription: {
            en: 'Explore approved axle oil specifications for Mercedes-Benz Trucks. Optimized for durability in heavy-duty applications.',
            de: 'Entdecke alle freigegebenen Achsöle und Spezifikationen für Lastkraftwagen von Mercedes-Benz Trucks. Abgestimmt auf den Einsatz unter anspruchsvollen Belastungen.',
            pt: 'Óleos de eixo aprovados para aplicações exigentes – freios eixos homologados para caminhões como o Actros, Arocs e Atego da Mercedes-Benz Trucks.'
        },
        keywords: {
            en: ['Axle oil', 'Approved axle oil', 'Mercedes-Benz', 'Truck', 'Actros', 'Arocs', 'Atego', 'Unimog', 'heavy-duty'],
            de: ['Achsöl', 'Freigegebene Achsöle', 'Lastkraftwagen', 'Actros', 'Arocs', 'Mercedes-Benz', 'Truck', 'Atego'],
            pt: ['Óleo de eixo', 'Óleos de eixo aprovado', 'Arocs', 'Atego', 'Mercedes-Benz', 'Truck', 'caminhõe']
        }
    },
    {
        icon: cleanerIcon,
        image: CleanerHeader,
        description: 'Cleaner',
        static: true,
        sheeTitle: "ClearCareProductsTitle",
        staticDetails: "ClearCareProductsDetails",
        filename: "cleaner.csv",
        link: '/cleaner-and-care',
        sheetPrefix: 39,
        metaDescription: {
            en: 'Recommended cleaning and care products from Mercedes-Benz Truck.',
            de: 'Empfohlene Reinigungsmittel und Pflegeprodukte für die Wartung und Pflege von Mercedes-Benz Truck.',
            pt: 'Produtos de limpeza e manutenção recomendados para a conservação e cuidado de veículos da Mercedes-Benz Truck.'
        },
        keywords: {
            en: ['Cleaning product', 'care product', 'Mercedes-Benz', 'Truck', 'Cleaner'],
            de: ['Reinigung', 'Reinigungsmittel', 'Pflegeprodukt', 'Wartung und Pflege', 'Mercedes-Benz', 'Truck'],
            pt: ['Produtos de limpeza', 'Produtos de manutenção', 'conservante', 'cuidado', 'Mercedes-Benz', 'Truck']
        }
    },
].sort((a, b) => a.sheetPrefix - b.sheetPrefix);

export const TABLE_HEADER: {
    [key: string]: { key: string; value: string };
} = {
    productName: {key: 'productName', value: 'ProductName'},
    description: {key: 'description', value: 'Principal'},
    type30: {key: 'type30', value: '30'},
    type40: {key: 'type40', value: '40'},
    type50: {key: 'type50', value: '50'},
    type80: {key: 'type80', value: '80'},
    type90: {key: 'type90', value: '90'},
    type0W: {key: 'type0W', value: '0W'},
    type0W20: {key: 'type0W20', value: '0W-20'},
    type0W30: {key: 'type0W30', value: '0W-30'},
    type0W40: {key: 'type0W40', value: '0W-40'},
    type5W20: {key: 'type5W20', value: '5W-20'},
    type5W30: {key: 'type5W30', value: '5W-30'},
    type5W40: {key: 'type5W40', value: '5W-40'},
    type5W50: {key: 'type5W50', value: '5W-50'},
    type10W: {key: 'type10W', value: '10W'},
    type10W30: {key: 'type10W30', value: '10W-30'},
    type10W40: {key: 'type10W40', value: '10W-40'},

    type10W60: {key: 'type10W60', value: '10W-60'},
    type15W40: {key: 'type15W40', value: '15W-40'},
    type20W20: {key: 'type20W20', value: '20W-20'},
    type20W50: {key: 'type20W50', value: '20W-50'},
    type75W: {key: 'type75W', value: '75W'},
    type75W80: {key: 'type75W80', value: '75W-80'},
    type75W85: {key: 'type75W85', value: '75W-85'},
    type75W90: {key: 'type75W90', value: '75W-90'},
    type80W: {key: 'type80W', value: '80W'},
    type80W90: {key: 'type80W90', value: '80W-90'},
    type80W85: {key: 'type80W85', value: '80W-85'},
    type85W90: {key: 'type85W90', value: '85W-90'},
};
